import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CrosshairIcon } from '@rsos/assets/icons';
import {
  AIR_AMBULANCE,
  TOW_PRO,
  setIsClickable,
} from '@rsos/reduxDataStore/src/features/geoSelection/geoSelectionSlice';
import {
  SelectorBanner,
  TextIconWrapper,
  IconWrapper,
  BannerText,
} from './SelectLocationBanner.styles';

type GeoSelectionKey = typeof AIR_AMBULANCE | typeof TOW_PRO;

interface GeoSelectionState {
  geoSelection: Record<GeoSelectionKey, { isClickable: boolean }>;
}

interface SelectLocationBannerProps {
  /** Which geoSelection slice key the banner toggles map clicks for. */
  geoSelectionKey?: GeoSelectionKey;
}

const SelectLocationBanner = memo(
  ({
    geoSelectionKey = AIR_AMBULANCE,
  }: SelectLocationBannerProps): JSX.Element => {
    const dispatch = useDispatch();
    /**
     * Determines if the map is interactive for tracking and recording
     * latitude/longitude coordinates.
     */
    const isClickable = useSelector(
      (state: GeoSelectionState) =>
        state.geoSelection[geoSelectionKey].isClickable,
    );
    const handleClick = (): void => {
      dispatch(
        setIsClickable({
          key: geoSelectionKey,
          isClickable: !isClickable,
        }),
      );
    };

    return (
      <SelectorBanner horizontal onClick={handleClick} isClicked={isClickable}>
        <TextIconWrapper horizontal>
          <IconWrapper isClicked={isClickable}>
            <CrosshairIcon />
          </IconWrapper>

          {isClickable ? (
            <BannerText isClicked={isClickable}>
              Click here to cancel location selection
            </BannerText>
          ) : (
            <BannerText isClicked={isClickable}>
              Click here to select location on map
            </BannerText>
          )}
        </TextIconWrapper>
      </SelectorBanner>
    );
  },
);

export default SelectLocationBanner;
